/**
 * `W5-T09` §4.9 — where the documents live on the web, and the booking page's read of its own.
 *
 * Loader-first (ADR-011 R3): a route's loader calls these and the components render what they
 * answered. The PDF is never read through the client: the page links to the API's route and the
 * browser downloads it with the session cookie, in the page's language (`?lang=`).
 */
import { type MoneyDocumentSummary } from '@marketplace/contracts';
import { type LoaderFunctionArgs } from 'react-router';
import { queryKeys, routeContext } from '../../../shared/query.js';

export const documentsPath = (locale: string): string => `/${locale}/account/documents`;

export const documentPath = (locale: string, id: string): string =>
  `${documentsPath(locale)}/${id}`;

export const documentPdfUrl = (id: string, locale: string): string =>
  `/api/documents/${id}/pdf?lang=${locale}`;

/**
 * The reader's documents for one booking, for the booking page's links (AC 37). `[]` says nothing:
 * a failed read never turns the booking page into an error.
 */
export async function loadBookingDocuments(
  context: LoaderFunctionArgs['context'],
  bookingId: string,
): Promise<readonly MoneyDocumentSummary[]> {
  const { queryClient, api } = context.get(routeContext);
  return queryClient
    .fetchQuery({
      queryKey: queryKeys.myDocuments(bookingId),
      queryFn: () => api.getMyDocuments({ bookingId }),
      staleTime: 0,
    })
    .then((page) => page.items)
    .catch(() => []);
}
